//import { useStore } from 'vuex'
import store from "@/store";

export function locationFullName(location) {
  if (location.owner_uuid) {
    //const store = useStore();
    const owner = store.getters.getLocationByUUID(location.owner_uuid);
    let fullName = locationFullName(owner)
    fullName.push(location.name)
    return fullName;
  } else {
    return [ location.name ];
  }
}

export function locationFullNameText(location) {
  if (location) {
    return locationFullName(location).reduce(function(str, n) {
      return (str.length > 0) ? (str + " :: " + n) : n
    }, "");
  } else {
    return null;
  }      
}